export const UI_CONSTANTS = {
  COLORS: {
    PRIMARY: '#DB4225',
    PRIMARY_BG: '#FDE7E2',
    PRIMARY_HOVER: '#FAD8D8',
    PRIMARY_HOVER_LIGHT: '#FAD8D8/60',
    TEXT_PRIMARY: '#000000',
    TEXT_SECONDARY: '#5F5F5F',
    TEXT_GRAY: '#787878',
    TEXT_GRAY_LIGHT: '#9CA3AF',
    BORDER_GRAY: '#E5E7EB',
  },
  SIZES: {
    POST_CARD_HEIGHT: '300px',
    POST_VIDEO_WIDTH: '180px',
    POST_CONTENT_WIDTH: '400px',
    POST_CONTENT_MAX_WIDTH: '480px',
    BRAND_CARD_MIN_WIDTH: '180px',
    BRAND_CARD_MAX_WIDTH: '200px',
    CREATOR_CARD_MIN_WIDTH: '276px',
    CREATOR_CARD_MAX_WIDTH: '320px',
  },
  SHADOWS: {
    SOCIAL_GLASS: 'shadow-socialglass',
    CARD: 'shadow-[0_4px_12px_rgba(0,0,0,0.05),0_-0px_16px_rgba(0,0,0,0.05)]',
  },
  ANIMATION: {
    DURATION: 0.4,
    DELAY_STEP: 0.1,
  },
} as const;
